import useCartItem from 'hooks/useCartItem'
import Image from 'snippets/image/image'
import QuantityInput from 'snippets/quantity-input/quantity-input'
import Price from 'snippets/price/price'
import Icon from 'snippets/icon/icon'
import { formatMoney } from 'libs/shopify'

function MiniCartItem({ item, setCart, setIsFetching }) {
  const { setQuantity, isLoading, maxQuantity, isDisabled, originalLinePrice, renderKey, customClassPrice, onRemove } = useCartItem(item, setCart, setIsFetching)
  const isPreorder = item?.tags.includes('pre-order')
  const isBundleItem = Boolean(item.properties?.['_bundle-id'])

  return (
    <div className="flex gap-4 py-4 border-t border-default first:border-t-0 last:pb-6 md:py-6">
      <div className="relative">
        <Image imageUrl={[item.featured_image.url]} imageClass="fit" className="w-20 aspect-1" key={item.id} />
      </div>
      <div className="flex flex-1 gap-2">
        <div className="flex-1">
          <a href={item.url} className="block mb-1 text-sm text-grey-1000" title={item.title}>
            {item.product_title}
          </a>
          <div className="text-xs text-grey-500">{item.properties?._package}</div>
          {isPreorder && <div className="mt-0.5 text-sm text-grey-500">{item?.properties?.preorder}</div>}
          <div className="mt-2">
            <Price
              price={item.line_price}
              originalPrice={originalLinePrice}
              className="flex flex-row-reverse justify-end gap-2 text-grey-700"
              classSize={customClassPrice}
              classColor="!text-accent-4"
            />
            {item.discounts.length ? (
              <div className="flex flex-row gap-2 mt-3">
                {item.discounts.map(discount => (
                  <div className="text-sm text-[#4A8F05] leading-6 tracking-[-0.24px] md:tracking-normal" key={discount.title}>{translate.cart.bundleDiscount.replace('{{ amount }}', formatMoney(discount.amount))}</div>
                ))}
              </div>
            ) : null}
            {!isBundleItem && (
              <div className="relative mt-4">
                <QuantityInput
                  inputKey={`${item.id}-${item.quantity}-${renderKey}`}
                  quantity={item.quantity}
                  min={1}
                  max={maxQuantity}
                  setQuantity={setQuantity}
                  disabled={isDisabled}
                  isLoading={isLoading}
                  classWrap="w-[122px] h-10"
                />
              </div>
            )}
          </div>
        </div>
        <button type="button" title='Remove product' onClick={onRemove} className="w-4 h-4 mt-1 text-grey-500">
          <Icon name="icon-trash-simple" viewBox="0 0 16 16" className="w-full h-full" />
        </button>
      </div>
    </div>
  )
}

export default MiniCartItem
